import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CountryWiseServiceRequirementFormComponent } from './country-wise-service-requirement-form/country-wise-service-requirement-form.component';
import { CountryWiseServiceRequirementListComponent } from './country-wise-service-requirement-list/country-wise-service-requirement-list.component';

const routes: Routes = [
    {
        path: '',
        data: { title: 'Country Wise Service Requirement' },
        component: CountryWiseServiceRequirementListComponent
    },
    {
        path: 'add',
        data: { title: 'Add Country Wise Service Requirement' },
        component: CountryWiseServiceRequirementFormComponent
    },
    {
        path: 'edit/:id',
        data: { title: 'Edit Country Wise Service Requirement' },
        component: CountryWiseServiceRequirementFormComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class CountryWiseServiceRequirementRoutingModule { }
